import type { FC } from 'react';
import { useEffect, useMemo } from 'react';
import type { CategorySB } from '@mwl/core-lib';
import { loadCategoriesRequest, selectCategories, selectCategoriesIsLoading, selectUserCurrency, useItemsFilteredByStage, useSportUrlParams } from '@mwl/core-lib';
import { Loader } from '@/components/Loader/Loader';
import { PerfectScrollbarWithShadow } from '@/components/PerfectScrollbarWithShadow/PerfectScrollbarWithShadow';
import { routes } from '@/constants';
import { useSportSidebarBehavior, useTypedDispatch, useTypedSelector } from '@/hooks';
import { SportCategoryItem } from '../SportCategoryItem/SportCategoryItem';
import styles from './SportCategoryList.module.scss';
export const SportCategoryList: FC = () => {
  const dispatch = useTypedDispatch();
  const currency = useTypedSelector(selectUserCurrency);
  const data = useTypedSelector(selectCategories);
  const isLoading = useTypedSelector(selectCategoriesIsLoading);
  const {
    createSportCategoryLink,
    stage
  } = useSportUrlParams({
    routes
  });
  const {
    sidebarIsOpened,
    sportId
  } = useSportSidebarBehavior();
  const categories = useMemo<Array<CategorySB>>(() => {
    if (!sportId || !data) {
      return [];
    }
    return data;
  }, [data, sportId]);
  const filteredCategories = useItemsFilteredByStage<CategorySB>(categories, stage);
  useEffect(() => {
    if (sportId && currency) {
      dispatch(loadCategoriesRequest({
        sportId: sportId ?? ''
      }));
    }
  }, [dispatch, sportId, currency]);
  if (!filteredCategories.length) {
    return null;
  }
  return <div className={cn(styles.root, {
    [styles.show]: sidebarIsOpened
  })} data-sentry-component="SportCategoryList" data-sentry-source-file="SportCategoryList.tsx">
      {isLoading ? <div className={styles.loader}>
          <Loader variant="sport" />
        </div> : <PerfectScrollbarWithShadow className={styles.scrollbar} options={{
      wheelPropagation: false
    }} isShowShadow isSwitchOffOnMobile={false} shadowVariant="dark80Shadow">
          <div className={styles.list}>
            {filteredCategories.map(category => <SportCategoryItem key={category.id} {...category} href={createSportCategoryLink(category)} categories={filteredCategories} />)}
          </div>
        </PerfectScrollbarWithShadow>}
    </div>;
};